import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Returns the current Cognito access token for use in Authorization: Bearer <token>.
 * Use this for API calls that require Cognito auth (e.g. renglo-api /_schd/...).
 */
export async function getAccessToken(): Promise<string> {
  try {
    const session = await fetchAuthSession();
    const raw = session.tokens?.accessToken?.toString();
    return typeof raw === 'string' ? raw : '';
  } catch {
    return '';
  }
}
